/**
 * Единый вид номера заказа в UI: #FRL-0029 … #FRL-3546 … #FRL-12345
 * До 9999 — минимум 4 цифры с ведущими нулями; от 10000 — без лишних нулей.
 */
export function orderRefLabel(orderId: number | string | undefined | null): string {
  const n = Number(orderId);
  if (!Number.isFinite(n) || n < 0) return '#FRL-—';
  const s = n < 10000 ? String(n).padStart(4, '0') : String(n);
  return `#FRL-${s}`;
}
